// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1BY1u","inner":"Footer_inner__3ESdj","nextIcon":"Footer_nextIcon__2w23y","innerLeft":"Footer_innerLeft__xprui"};